import { Box, IconButton, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Clear";
import React, { useState, useEffect } from "react";
import theme from "Theme/AppTheme";

type ErrorHandlerProps = {
    hasError?: boolean;
    errorMessage: React.ReactNode;
    showCloseButton?: boolean;
};

const ErrorHandler: React.FC<ErrorHandlerProps> = ({
    hasError,
    errorMessage,
    showCloseButton = true,
}) => {
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        setShowError(!!hasError);
    }, [hasError]);

    return showError ? (
        <Box
            sx={{
                padding: theme.spacing(0, 1, 0, 2),
                background: theme.palette.error[100],
                gap: theme.spacing(2),
                borderRadius: 2,
                display: "flex",
                color: theme.palette.error[700],
                alignItems: "center",
                marginBottom: theme.spacing(2),
            }}
        >
            <InfoOutlinedIcon color="inherit" />
            <Typography
                sx={{
                    color: "inherit",
                    fontSize: "14px",
                    fontWeight: 600,
                }}
            >
                {errorMessage}
            </Typography>
            {showCloseButton && (
                <IconButton
                    sx={{ marginLeft: "auto" }}
                    color="inherit"
                    onClick={() => setShowError(false)}
                >
                    <CloseIcon />
                </IconButton>
            )}
        </Box>
    ) : null;
};

export default ErrorHandler;
